// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"ea1fa7b8","6850":"283f3e23","6942":"b644ccc8"}[chunkId] + ".chunk.css";
};